// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__13_2N","header":"ReportDetails_header__2JHul","title":"ReportDetails_title__f7FGE","left":"ReportDetails_left__2a2gD"};